var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.31669 6.8525C2.53707 7.77265 1.95654 8.84434 1.61169 10C2.68836 13.615 6.03669 16.25 10 16.25C10.8275 16.25 11.6275 16.135 12.3859 15.9208M5.19003 5.19C6.61723 4.24822 8.2901 3.7474 10 3.75C13.9634 3.75 17.3109 6.385 18.3875 9.99833C17.7975 11.9728 16.5309 13.6763 14.81 14.81M5.19003 5.19L2.50003 2.5M5.19003 5.19L8.23169 8.23167M14.81 14.81L17.5 17.5M14.81 14.81L11.7684 11.7683C12.0005 11.5362 12.1847 11.2605 12.3103 10.9572C12.436 10.6539 12.5007 10.3287 12.5007 10.0004C12.5007 9.67208 12.436 9.34697 12.3103 9.04363C12.1847 8.74029 12.0005 8.46467 11.7684 8.2325C11.5362 8.00033 11.2606 7.81617 10.9572 7.69052C10.6539 7.56487 10.3288 7.5002 10.0004 7.5002C9.67211 7.5002 9.34699 7.56487 9.04365 7.69052C8.74031 7.81617 8.46469 8.00033 8.23253 8.2325M11.7675 11.7675L8.23336 8.23333",
    stroke: "#525355",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.5cceff664bb102c0ffcf28f34c6fb595.svg";
export { ForwardRef as ReactComponent };